import * as React from 'react';
import type { SVGProps } from 'react';
const SvgNewTagCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={11} height={9} fill="none" {...props}>
    <path stroke="#FFFFFF" strokeWidth={2} d="M1 4.833 3.77 7.5l6.23-6" />
  </svg>
);
export default SvgNewTagCheck;
